{
  "cycle.entite.organisation_cles_api": "Organisation API keys",
  "cycle.entite.organisation_cles_api_rotations": "API key replacements",
  "journalAudit.action.org.api_key.created": "API key created",
  "journalAudit.action.org.api_key.revoked": "API key revoked",
  "journalAudit.action.org.api_key.rotated": "API key replaced",
  "journalAudit.action.org.api_key.rotation_abandoned": "API key replacement abandoned",
  "journalAudit.action.org.api_key.taken_over": "API key taken over",
  "journalAudit.action.org.api_key.used": "Call with an API key",
  "v8c.clesapi.annuler": "Cancel",
  "v8c.clesapi.choisir": "Choose…",
  "v8c.clesapi.code.CLE_DEJA_REVOQUEE": "This key is already revoked.",
  "v8c.clesapi.code.CLE_DROITS_HORS_PORTEE": "You do not hold a chosen right yourself on this scope.",
  "v8c.clesapi.code.CLE_DROIT_NON_DELEGABLE": "A chosen right is never delegable to a key.",
  "v8c.clesapi.code.CLE_EXPIRATION_INVALIDE": "Invalid expiry date: future, one year at most, different from the old one.",
  "v8c.clesapi.code.CLE_NOM_DEJA_UTILISE": "A key with this name already exists in the organisation.",
  "v8c.clesapi.code.CLE_NON_SUSPENDUE": "This key is not suspended.",
  "v8c.clesapi.code.CLE_REPRENEUR_SANS_LES_DROITS": "The new owner does not hold all of the key’s rights on its scope.",
  "v8c.clesapi.code.CLE_ROTATION_EXPIREE": "Replacement abandoned (time limit passed): the new key is revoked, the old one stays valid.",
  "v8c.clesapi.code.CLE_ROTATION_RESPONSABLE_OU_DROITS_CHANGES": "The owner or their rights changed since opening: nothing was revoked.",
  "v8c.clesapi.code.CLE_SUSPENDUE_REPRENDRE_D_ABORD": "Suspended key: take it over first.",
  "v8c.clesapi.code.DROIT_NON_TENU": "You do not hold the right to manage API keys.",
  "v8c.clesapi.code.RESOURCE_UNAVAILABLE": "Key not found.",
  "v8c.clesapi.code.VALIDATION_ERROR": "Incomplete or invalid input.",
  "v8c.clesapi.col.actions": "Actions",
  "v8c.clesapi.col.derniere_utilisation": "Last used",
  "v8c.clesapi.col.expire_le": "Expires on",
  "v8c.clesapi.col.nom": "Name",
  "v8c.clesapi.col.portee": "Scope",
  "v8c.clesapi.col.responsable": "Owner",
  "v8c.clesapi.col.statut": "Status",
  "v8c.clesapi.creer.aucun_droit": "You hold no delegable right on this scope.",
  "v8c.clesapi.creer.aucun_espace": "No accessible space of this type.",
  "v8c.clesapi.creer.bouton": "Create the key",
  "v8c.clesapi.creer.bouton_ouvrir": "Create an API key",
  "v8c.clesapi.creer.choix_programme": "Programme",
  "v8c.clesapi.creer.choix_projet": "Project",
  "v8c.clesapi.creer.droits": "Key rights",
  "v8c.clesapi.creer.droits_proposables": "Available rights",
  "v8c.clesapi.creer.echec": "The key was not created.",
  "v8c.clesapi.creer.espaces": "Your spaces",
  "v8c.clesapi.creer.exclus": "{{n}} right(s) never delegable to a key",
  "v8c.clesapi.creer.expiration": "Expiry date",
  "v8c.clesapi.creer.expiration_aide": "Required: 30 days by default, one year at most.",
  "v8c.clesapi.creer.faite": "Key created: keep its secret now.",
  "v8c.clesapi.creer.nom": "Name",
  "v8c.clesapi.creer.nom_invalide": "The name is required (100 characters at most).",
  "v8c.clesapi.creer.plafond": "Only the rights you hold yourself on the chosen scope are offered.",
  "v8c.clesapi.creer.portee": "Scope",
  "v8c.clesapi.creer.portee_d_abord": "First choose the programme or project of the scope.",
  "v8c.clesapi.creer.titre": "Create an organisation API key",
  "v8c.clesapi.creer.usage": "Purpose (optional)",
  "v8c.clesapi.etat.chargement": "Loading: {{quoi}}…",
  "v8c.clesapi.etat.en_cours": "In progress…",
  "v8c.clesapi.etat.erreur": "Could not load: {{quoi}}.",
  "v8c.clesapi.etat.introuvable": "{{quoi}} not found.",
  "v8c.clesapi.etat.reessayer": "Retry",
  "v8c.clesapi.etat.refus": "Access denied: {{quoi}}.",
  "v8c.clesapi.exclusion.decision_humaine": "human decision (validate, publish, approve)",
  "v8c.clesapi.exclusion.personnel": "personal right",
  "v8c.clesapi.exclusion.reserve_au_proprietaire": "reserved to the owner",
  "v8c.clesapi.expiration.ancienne": "Choose a date different from the old key’s.",
  "v8c.clesapi.expiration.obligatoire": "Expiry date required (YYYY-MM-DD).",
  "v8c.clesapi.expiration.passee": "This date is already past.",
  "v8c.clesapi.expiration.un_an": "A key expires within one year at most.",
  "v8c.clesapi.fiche.creee_par": "Created by",
  "v8c.clesapi.fiche.droits_et_portee": "Rights and scope",
  "v8c.clesapi.fiche.effectifs": "Effective rights: {{n}} of {{total}}, capped by the owner’s and recomputed on every call.",
  "v8c.clesapi.fiche.expire_le": "Expires on {{date}}",
  "v8c.clesapi.fiche.identite": "Key identity",
  "v8c.clesapi.fiche.identite_de_service": "Organisation service identity",
  "v8c.clesapi.fiche.journal_attribue": "Each call is logged under the key and its owner at the time of the call.",
  "v8c.clesapi.fiche.libelle": "API key",
  "v8c.clesapi.fiche.parti": "left the organisation",
  "v8c.clesapi.fiche.plafonne": "not held by the owner",
  "v8c.clesapi.fiche.portee": "Scope: {{portee}}",
  "v8c.clesapi.fiche.reprise_par": "Taken over by",
  "v8c.clesapi.fiche.responsable": "Current owner",
  "v8c.clesapi.fiche.revoquee_le": "Revoked on {{date}} by {{nom}}",
  "v8c.clesapi.fiche.titre": "Organisation API key",
  "v8c.clesapi.jamais_utilisee": "Never used",
  "v8c.clesapi.liste.intro": "A key acts on behalf of the organisation, attributed to its owner; its secret is shown only once.",
  "v8c.clesapi.liste.libelle": "API keys",
  "v8c.clesapi.liste.titre": "Organisation API keys",
  "v8c.clesapi.liste.vide": "No API key in the organisation.",
  "v8c.clesapi.onglet.apercu": "Overview",
  "v8c.clesapi.onglet.cles": "API keys",
  "v8c.clesapi.onglets": "Organisation sections",
  "v8c.clesapi.portee.organisation": "Whole organisation",
  "v8c.clesapi.portee.programme": "Programme",
  "v8c.clesapi.portee.projet": "Project",
  "v8c.clesapi.remplacer.annuler_apres": "Cancelling now revokes the new key; the old one stays valid.",
  "v8c.clesapi.remplacer.bouton_ouvrir": "Replace the key",
  "v8c.clesapi.remplacer.cesse_maintenant": "The old key stops working as soon as you confirm.",
  "v8c.clesapi.remplacer.confirmer": "Confirm and revoke the old key",
  "v8c.clesapi.remplacer.conserver_d_abord": "First tick “I have kept the secret”.",
  "v8c.clesapi.remplacer.conserves": "Scope {{portee}}, rights and owner ({{responsable}}) are kept.",
  "v8c.clesapi.remplacer.creer": "Create the new key",
  "v8c.clesapi.remplacer.echec": "The new key was not created.",
  "v8c.clesapi.remplacer.echec_abandon": "Cancelling failed: the new key may not be revoked; try “Cancel” again.",
  "v8c.clesapi.remplacer.echec_confirmation": "The replacement was not confirmed.",
  "v8c.clesapi.remplacer.en_attente": "The new key stays pending until you confirm (by {{echeance}} at the latest); this secret will never be shown again.",
  "v8c.clesapi.remplacer.expiration": "New key expiry",
  "v8c.clesapi.remplacer.expiree": "The old key has expired: choose the new expiry.",
  "v8c.clesapi.remplacer.revoquee": "This key was revoked in the meantime: nothing to replace.",
  "v8c.clesapi.remplacer.suspendue": "Suspended key: first take over responsibility for this key.",
  "v8c.clesapi.remplacer.titre": "Replace an API key",
  "v8c.clesapi.reprise.aucun": "No member holds all of this key’s rights on its scope.",
  "v8c.clesapi.reprise.bouton": "Take over the key",
  "v8c.clesapi.reprise.choisir_d_abord": "First choose who takes over.",
  "v8c.clesapi.reprise.echec": "The takeover was not saved.",
  "v8c.clesapi.reprise.explication": "Its owner {{nom}} left the organisation: the key is suspended until a member holding its rights takes it over.",
  "v8c.clesapi.reprise.faite": "Key taken over: it is active again.",
  "v8c.clesapi.reprise.repreneur": "New owner",
  "v8c.clesapi.reprise.repreneurs": "Possible new owners",
  "v8c.clesapi.revocation.bouton": "Revoke the key",
  "v8c.clesapi.revocation.confirmation": "Revoke “{{nom}}”? The effect is immediate and permanent: any call with this key will be refused.",
  "v8c.clesapi.revocation.confirmer": "Revoke permanently",
  "v8c.clesapi.revocation.echec": "The key was not revoked.",
  "v8c.clesapi.revocation.faite": "Key revoked.",
  "v8c.clesapi.secret.case_conserve": "I have kept the secret",
  "v8c.clesapi.secret.conserve": "I have kept the secret",
  "v8c.clesapi.secret.copie": "Secret copied.",
  "v8c.clesapi.secret.copie_refusee": "The browser refused to copy: select the secret and copy it.",
  "v8c.clesapi.secret.copier": "Copy the secret",
  "v8c.clesapi.secret.quitter": "The secret will never be shown again. Leave anyway?",
  "v8c.clesapi.secret.quitter_confirmer": "Leave",
  "v8c.clesapi.secret.rester": "Stay",
  "v8c.clesapi.secret.titre": "Key secret",
  "v8c.clesapi.secret.titre_nouveau": "New key secret",
  "v8c.clesapi.secret.une_fois": "This secret is shown only once: copy it to your vault now.",
  "v8c.clesapi.secret.valeur": "Secret",
  "v8c.clesapi.statut.active": "Active",
  "v8c.clesapi.statut.en_attente_de_confirmation": "Pending confirmation",
  "v8c.clesapi.statut.expire_bientot": "Expires soon",
  "v8c.clesapi.statut.expiree": "Expired",
  "v8c.clesapi.statut.revoquee": "Revoked",
  "v8c.clesapi.statut.suspendue": "Suspended",
  "v8c.clesapi.toutes_les_cles": "All keys",
  "v8c.clesapi.utilisations.libelle": "Recent uses",
  "v8c.clesapi.utilisations.ligne": "{{date}} — {{methode}} {{chemin}} from {{adresse}} (owner {{responsable}})",
  "v8c.clesapi.utilisations.titre": "Recent uses",
  "v8c.clesapi.utilisations.vide": "No recorded use.",
  "v8c.clesapi.voir": "View",
  "v8c.clesapi.voir_la_cle": "View key {{nom}}"
}
